/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilityIssueTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ThreatVulnerabilityIssueTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return ThreatVulnerabilityIssueTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilityIssueTypeQueryOperator>): ThreatVulnerabilityIssueTypeQueryOperator {
        let obj = Object.assign(new ThreatVulnerabilityIssueTypeQueryOperator(), model);
        ThreatVulnerabilityIssueTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilityIssueTypeQueryOperator>): ThreatVulnerabilityIssueTypeQueryOperator {
        if (!model) return null;
        return ThreatVulnerabilityIssueTypeQueryOperator.newInstance(<ThreatVulnerabilityIssueTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilityIssueTypeQueryOperator) {
        if (!obj) return;

        models.ThreatVulnerabilityIssueTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilityIssueTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatVulnerabilityIssueTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Issue types to include
     */
    issue_types: Array<string>;

}
